import { render, staticRenderFns } from "./ClinicPackageModal.vue?vue&type=template&id=7dc24c92&scoped=true"
import script from "./ClinicPackageModal.vue?vue&type=script&lang=js"
export * from "./ClinicPackageModal.vue?vue&type=script&lang=js"
import style0 from "./ClinicPackageModal.vue?vue&type=style&index=0&id=7dc24c92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc24c92",
  null
  
)

export default component.exports